import React from "react";
import styled from "styled-components";
import Report1 from "../../../assets/image/report1.png"
import Report2 from "../../../assets/image/report2.png"

const Container = styled.div`
  padding: 1.5em;
  background: #f8f8f8;
`;

const Heading = styled.h1`
  margin-top: 0;
  color: ${({ colors }) => colors.labelText};
`;

const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: flex-start;
`;

const Item = styled.div`
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
  text-align: center;
  width: 200px;
`;

const Card = styled.div`
  perspective: 800px;
  &:hover img {
    transform: rotateX(0deg) rotateY(0deg) scale(1.05);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  }
`;

const ShadowContent = styled.div`
  padding: 10px;
`;

const CardImage = styled.img`
  width: 150px;
  height: 194px;
  display: block;
  margin: 0 auto;
  transform-style: preserve-3d;
  transform: rotateX(8deg) rotateY(-8deg);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
`;

const ReportLink = styled.a`
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
  display: block;
  margin-top: 8px;
  color: ${({ colors }) => colors.buttonBackground};
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export default function ReportsContent({ colors, onSelectTab }) {
  const reports = [
    {
      key: "compliance",
      tab: "Compliance Doc Reports",
      img: Report1,
      label: "Compliance Documentation Report",
    },
    {
      key: "certification",
      tab: "Certification Reports",
      img: Report2,
      label: "PDP Certification Report",
    },
    {
      key: "erate",
      tab: "E-Rate Cert Reports",
      img: Report2,
      label: "Educator E-Rate Certification Report",
    },
    {
      key: "module-download",
      tab: "Module Download Report",
      img: Report2,
      label: "Educator Module Download Report",
    },
  ];

  return (
    <Container id="bigbox">
      <Heading colors={colors}>Reports</Heading>

      <Cards>
        {reports?.map((r) => (
          <Item key={r.key}>
            <Card>
              <ShadowContent>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    onSelectTab(r.tab);
                  }}
                >
                  <CardImage src={r.img} alt={r.label} />
                </a>
              </ShadowContent>
            </Card>
            <ReportLink
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onSelectTab(r.tab);
              }}
              colors={colors}
            >
              {r.label}
            </ReportLink>
          </Item>
        ))}
      </Cards>
    </Container>
  );
}
